<template>
  <div class="articles">
    <h1 class="title">{{ category.title }}</h1>
    <div>
      <ul class="list pa0 ma0">
        <li class="mb3" v-for="article in paginatedOrders" :key="article.name">
          <button
            class="article-button"
            :class="{
              'article-button--active': openArticleIds.includes(article.id)
            }"
          >
            <a
              :data-article="article.id"
              @click.prevent="showArticle"
              style="color: inherit; text-decoration: inherit;"
              v-bind:href="`#${article.source_id}-${article.title.replace(/ /g, '-')}`"
              >{{ article.title }}</a
            >
          </button>
          <div :id="`art-${article.id}`" class="article-body">
            <div v-html="article.body" data-external="articles"></div>
          </div>
        </li>
      </ul>
      <div class="container">
        <button @click="loadMore" v-if="currentPage * maxPerPage < articles.length" class="button__show-more">
          Show more
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M3 4.5l2.6 2.6c.2.2.5.2.7 0L9 4.5"></path></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage, replaceMaHcLoginSupportContent , getSpecificArticleFromStore} from '@/utils/common';
export default {
  props: {
    name
  },
  data() {
    return {
      openArticleIds: [],
      currentPage: 1,
      maxPerPage: 20,
    };
  },
  updated() {
    replaceMaHcLoginSupportContent();
  },
  methods: {
    handleArticleClick(id) {
      if (this.openArticleIds.includes(id)) {
        let index = this.openArticleIds.indexOf(id);

        this.openArticleIds.splice(index, 1);
      } else {
        this.openArticleIds.push(id);
      }
    },
    showArticle(e) {
      let articleId = e.target.dataset.article;
      let element = document.querySelector(`#art-${articleId}`);
      if (this.openArticleIds.includes(articleId)) {
        element.style['max-height'] = `0px`;
        element.classList.remove('active');
        this.handleArticleClick(articleId);
        return;
      }
      element.style['max-height'] = `${element.scrollHeight}px`;
      element.style['transition'] = '0.5s';
      this.handleArticleClick(articleId);
      element.classList.add('active');
      this.activeArticle = articleId;
    },
    loadMore() {
      this.currentPage += 1;
    }
  },
  computed: {
    pageTitle() {
      const pageTitle = this.name;
      return pageTitle;
    },
    category() {
      const name = this.$store.state.categories[this.$route.meta.categoryId];
      return name;
    },
    articles() {
      const faq_1 = getSpecificArticleFromStore('4407712704788');
      const faq_2 = getSpecificArticleFromStore('8850497911444');
      const faq_3 = getSpecificArticleFromStore('8850500224532');
      const faq_4 = getSpecificArticleFromStore('8850501238548');
      const faq_5 = getSpecificArticleFromStore('4407712695060');
      const faq_6 = getSpecificArticleFromStore('4407712634516');
      const faq_7 = getSpecificArticleFromStore('4407712689812');
      const faq_8 = getSpecificArticleFromStore('4407712762132');
      const faq_9 = getSpecificArticleFromStore('8850552632852');
      const faq_10 = getSpecificArticleFromStore('8850553419796');

      return [faq_1, faq_2, faq_3, faq_4, faq_5, faq_6, faq_7, faq_8, faq_9, faq_10];
    },
    paginatedOrders() {
      return this.articles.slice(0, this.currentPage * this.maxPerPage);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.articles {
  .title {
    color: #101218;
    margin-bottom: 0.2rem;
    font-size: 32px;
  }
}

.article-button {
  color: #F04682;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  transition: 0.1s linear color;
  padding: 0.2rem 0;
  width: 100%;

  a {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
  &:hover {
    color: #F04682;
  }
  &--active {
    margin: 0;
  }
}
a {
  color: #F04682!important;
}

a:hover {
  border-color: #F04682!important;
}
.article-body {
  // -webkit-transition: max-height 0.3s cubic-bezier(0, 1, 0, 1); /* For Safari 3.1 to 6.0 */
  transition: 1s;
  max-height: 0px;
  overflow: hidden;
  font-size: 14px;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  color: #101218 !important;
  font-weight: 600;
  a {
    color: #F04682 !important;
    text-decoration: none;
  }
}
.container {
  display: flex;
}
.button__show-more {
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #3bb4ef;
    flex: 1 1 auto;
    text-align: center;
    margin: 0;
    padding: 0;

    &:hover {
      background-color: transparent;
      color: #3bb4ef;
      text-decoration: underline;
    }

  svg {
    display: inline-block;
    margin-left: 1px;
    vertical-align: middle;
  }
}

*{
  font-family: 'Source Sans Pro',Arial, Helvetica, sans-serif!important;
  color:#fff!important;
}

html, body {
  background-color: #fbfbfb;
}

a {
  color: #F04682!important;
}

a:hover {
  border-color: #F04682!important;
}

.header {
  padding: 0 30px 30px 30px;
  background-color: #101218;
  margin-bottom:50px!important;
}

.sidebar .icon .polygon{
  fill: #F04682!important;
}
.sidebar a { color:#F04682!important;}
.sidebar span { color:#F04682!important;}
.input-group--search{
  background-color: transparent!important;
}


.input-group--search .input {
  border-radius: 5px;
  background-color: #ffffff;
  color:#101218!important;
  border: 1px solid rgba($color: #ffffff, $alpha: 0.1)!important;
  padding-left: 45px!important;
}

.input-group--search .input::placeholder { color: rgba($color: #101218, $alpha: 0.5)!important;}
.autocomplete-results {background-color: #31343E!important; border-color: rgba($color: #ffffff, $alpha: 0.1)!important;}

.input-group--search .icon {
  background-color: transparent!important;
  float: left!important;
  display: inline-block;
  left:1rem!important;
  top: 66%!important;
}

.category-boxes__item__link {
  background-color: #ffffff;
  color:#101218!important;
}
.category-boxes__item__link a, .category-boxes__item__link h3, .category-boxes__item__link p {
  color:#101218!important;
}

.category-boxes__item__link p { font-weight: 500;}

.category-boxes__item__link:hover {
  background-color:#fff!important;
  color:#101218!important;
}

.category-boxes__item__link:hover * {
  color:#101218!important;
}

h1.stage__title {
  text-transform: none!important;
}

.category-boxes__item__link .icon polygon, .category-boxes__item__link .icon path {
  fill: #F04682!important;
}

.footer__header {
  background-color: #ecece8!important;
  color: #101218!important;
  border : none!important;
}
.footer__header p { color:#101218!important;}

.footer__item__link {
  border-radius: 5px!important;
  border: 1px solid #ddddd9!important;
  background-color:#ffffff!important;
  color:#101218!important;
}

.footer__item__link h4 {
  color:#101218!important;
}

.footer__item__modals, .footer__item__modals h2{
  color:#101218!important;
}

.footer__modal-option::after {
  color:#F04682!important;
}

.footer__modal-link-text {
  background-color: #F04682!important;
}

.footer__modal-title{
  color: #101218!important;
}

.footer { margin-top: 140px!important;}



.language-dropdown__list .text, .language-dropdown__list .link { color:#101218!important; }

.ma0 { font-weight: 700; }
.stage__text .link { font-weight: 600;}

.content__main { padding:20px!important; border-radius: 5px; background-color: #ffffff; color:#101218!important; border: 1px solid #eeeeee;}
.articles .title { color:#101218!important; }
.content__main h1 { color:#101218!important; }
.article-body, .article-body * { color:#101218!important; font-weight: 600;}
.content__aside .sidebar__links { background-color: #fff; border: 1px solid #eeeeee; border-radius: 5px; position: relative; top:-50px;}
.footer__modal-option a { font-weight: 600!important;}
.footer__modal-link { border-radius: 5px; }

// Contact page,  Links in articles
.article-body, .article-body a { color:#F04682!important;}


.row-container * { color:#101218!important}
.row-container a { color:#F04682!important}
.stage__text .stage__text__question { color:#fff!important; }
.input-group--btns { margin: 5px 0 20px!important; padding:0!important}
.input-group--btns button {background-color: #F04682!important; color:#fff!important; font-weight: 600!important;}

.articles ::v-deep a {
  color: #F04682 !important;
}
</style>
